import React from 'react';
import axios from 'helpers/axios';
import _ from 'lodash';

import {
  Form,
  Container,
  Title,
  TextInput,
  Button,
  Label,
  ToggleSwitch,
  MultiTextInput,
} from 'ui/components/styled';
import { useToasts, useCompany } from 'hooks';
import { ValidationPattern } from 'helpers/form';
import { defaultJobSettings } from 'providers/company';

export const EditCompany = ({ company, onClose, onSuccess }) => {
  const [state, setState] = React.useState({
    hoursUntilWarning: company?.settings?.hoursUntilWarning || '',
    emailCapacity: company?.settings?.emailCapacity || '',
    notifications: {
      enabled: company?.settings?.notifications?.enabled || false,
      receivers: company?.settings?.notifications?.receivers || [],
    },
    reports: {
      receivers: company?.settings?.reports?.receivers || [],
    },
  });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();
  const { refreshCompanies } = useCompany();
  const notificationsReceiversRef = React.useRef();

  const handleChange = (e) => {
    const { name, type } = e.target;
    const value = type === 'checkbox' ? e.target.checked : e.target.value;
    _.set(state, name, value);
    setState({ ...state });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.put(`/companies/${company?.id}`, {
        settings: {
          ...state,
          hoursUntilWarning:
            parseInt(state.hoursUntilWarning) || defaultJobSettings.hoursUntilWarning,
          emailCapacity: parseInt(state.emailCapacity) || defaultJobSettings.emailCapacity,
        },
      });
      if (response.status === 200) {
        removeAllToasts();
        successToast('Company updated successfully!');
        refreshCompanies();
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess();
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Edit Company.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Edit company
        </Title>
      </Container>
      <Container mb="s">
        <Label htmlFor="hours-until-warning" mb="xs">
          Hours until warning
        </Label>
        <TextInput
          id="hours-until-warning"
          name="hoursUntilWarning"
          type="number"
          min="1"
          placeholder="Hours until warning"
          variant="minimal"
          value={state.hoursUntilWarning}
          onChange={handleChange}
          required
        />
      </Container>
      <Container mb="s">
        <Label htmlFor="email-capacity" mb="xs">
          Email capacity
        </Label>
        <TextInput
          name="emailCapacity"
          type="number"
          min="1"
          placeholder="Email capacity"
          variant="minimal"
          value={state.emailCapacity}
          onChange={handleChange}
          required
        />
      </Container>
      <Container mb="s">
        <Label htmlFor="notifications" mb="xs">
          Notifications to
        </Label>
        <Container flexDirection="row" alignItems="center">
          <ToggleSwitch
            id="notifications"
            name="notifications.enabled"
            testId="notifications-toggle"
            checked={state.notifications?.enabled}
            onChange={(event) => {
              handleChange(event);
              if (event.target.checked) {
                notificationsReceiversRef.current.focus();
              }
            }}
            mr="s"
          />
          <MultiTextInput
            ref={notificationsReceiversRef}
            variant="minimal"
            placeholder="Email receivers"
            value={state.notifications?.receivers}
            onChange={(values) =>
              handleChange({
                target: {
                  name: 'notifications.receivers',
                  value: values,
                },
              })
            }
            validateValues={(value) => {
              const regex = new RegExp(ValidationPattern.email, 'i');
              const isValid = regex.test(value);
              if (!isValid) {
                errorToast('Please enter a valid email address.');
              }
              return isValid;
            }}
            disabled={!state.notifications?.enabled}
            required
          />
        </Container>
      </Container>
      {/*
      <Container>
        <Label htmlFor="reports" mb="xs">
          Reports to
        </Label>
        <MultiTextInput
          variant="minimal"
          placeholder="Reports receivers"
          value={state.reports?.receivers}
          onChange={(values) =>
            handleChange({
              target: {
                name: 'reports.receivers',
                value: values,
              },
            })
          }
          validateValues={(value) => {
            const regex = new RegExp(ValidationPattern.email, 'i');
            const isValid = regex.test(value);
            if (!isValid) {
              errorToast('Please enter a valid email address.');
            }
            return isValid;
          }}
          mb="s"
        />
      </Container>
      */}
      <Container mb="m">
        <Label variant="legend">These are the default settings for each new monitor created.</Label>
      </Container>
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width="30%" disabled={preventSubmit}>
          Save
        </Button>
      </Container>
    </Form>
  );
};
